<template>
  <div class="work_with_us_image_container left">
    <img
      src="/images/work-with-us/work_with_us_left.webp"
      class="work_with_us_left"
      alt="work_with_us_left"
    />
  </div>

  <div class="work_with_us_image_container right">
    <img
      src="/images/work-with-us/work_with_us_right.webp"
      class="work_with_us_left"
      alt="work_with_us_left"
    />
  </div>
</template>

<style lang="scss">
.work_with_us_image_container {
  width: 50%;
  height: 100%;
  max-height: 650px;
  overflow: hidden;
  position: absolute;
  max-width: 700px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  z-index: -1;
  &.right {
    top: 0;
    right: 0;

    .work_with_us_left {
      transform: translateY(-100px); /* Adjust the value as needed */
    }
  }
  &.left {
    top: 0;
    left: 0;
  }

  .work_with_us_left {
    width: 100%;
    height: auto;
    object-fit: cover;
    object-position: center;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(
      closest-side,
      rgba(5, 6, 7, 0.3) 0%,
      rgba(5, 6, 7, 1) 100%
    );
    pointer-events: none;
    z-index: 1;
  }

  @media screen and (max-width: 1100px) {
    max-width: 100%;
    width: 100%;
    max-height: 617px;

    &.right {
      display: none;
    }
  }

  @media screen and (max-width: 850px) {
    width: calc(100% + 100px) !important;
    max-width: calc(100% + 100px) !important;
    max-height: 100vh;
    transform: translateY(-70px);
    object-position: top top;
    &::after {
      background: linear-gradient(
        to bottom,
        rgba(5, 6, 7, 1) 0%,
        rgba(5, 6, 7, 0.2) 50%,
        rgba(5, 6, 7, 1) 65%,
        rgba(5, 6, 7, 1) 100%
      );
    }
    &.left {
      left: -50px;
    }
  }
}
</style>
